const IDENTITY_FIELD_KEYS = new Set([
  'title',
  'sku',
  'barcode',
  'handle',
]);

const PRODUCT_ONLY_IDENTITY_KEYS = new Set(['title', 'handle']);

export const isIdentityMasterFieldKey = (fieldKey, { isMeta } = {}) => (
  !isMeta && IDENTITY_FIELD_KEYS.has(fieldKey)
);

export const buildIdentityMasterUpdateData = (fieldKey, value, { isClear } = {}) => {
  if (!IDENTITY_FIELD_KEYS.has(fieldKey)) return null;
  if (isClear && fieldKey === 'title') return null;

  const resolvedValue = isClear ? '' : value;
  if (resolvedValue == null) return { [fieldKey]: '' };

  const stringValue = String(resolvedValue);
  if (fieldKey === 'title' && !stringValue.trim()) return null;

  return { [fieldKey]: stringValue };
};

export const collectMasterSelectionEntries = (selection = {}) => {
  const products = [];
  const variants = [];

  (selection.keys || []).forEach((key) => {
    const entry = selection.byKey?.[key];
    if (entry?.type === 'master' && entry._id) products.push(entry);
    if (entry?.type === 'masterVariant' && entry._id) variants.push(entry);
  });

  return { products, variants };
};

export const resolveIdentityMasterWriteTarget = (fieldKey, { target } = {}) => {
  if (PRODUCT_ONLY_IDENTITY_KEYS.has(fieldKey)) return 'product';
  if (target === 'variant') return 'variant';
  return 'product';
};

const pickIdentityWriteTarget = (products, variants, fieldKey, { target } = {}) => {
  const writeTarget = resolveIdentityMasterWriteTarget(fieldKey, { target });

  if (writeTarget === 'variant') {
    if (variants.length !== 1) return null;
    const variant = variants[0];
    const productId = variant.baseProductId || variant.productId;
    if (!productId) return null;
    return {
      kind: 'variant',
      productId,
      variantId: variant._id,
    };
  }

  if (products.length !== 1) return null;
  return {
    kind: 'product',
    productId: products[0]._id,
  };
};

export const pickIdentityMasterWriteTarget = (selection, fieldKey, { target } = {}) => {
  const { products, variants } = collectMasterSelectionEntries(selection);
  return pickIdentityWriteTarget(products, variants, fieldKey, { target });
};

export const collectListingSelectionEntries = (selection = {}) => {
  const products = [];
  const variants = [];

  (selection.keys || []).forEach((key) => {
    const entry = selection.byKey?.[key];
    if (entry?.type === 'listing' && entry._id) products.push(entry);
    if (entry?.type === 'listingVariant' && entry._id) variants.push(entry);
  });

  return { products, variants };
};

export const pickIdentityListingWriteTarget = (selection, fieldKey, { target } = {}) => {
  const { products, variants } = collectListingSelectionEntries(selection);
  return pickIdentityWriteTarget(products, variants, fieldKey, { target });
};
